import {writable} from 'svelte/store';

const initState = {
    basket: undefined,

    errors: undefined,

    product: undefined,
    productRequiredFunctionality: 'product_page',

    productModal: false,

    onProductModalHide: null,

    offerAvailable: false,

    usage: null
};

function BasketStore(state = initState) {
    const {
        subscribe,
        update
    } = writable(state);

    function updateState(data) {
        Object.entries(data)
            .forEach(([dataName, newData]) => {
                update((storeState) => {
                    storeState[dataName] = newData;

                    return storeState;
                });
            });
    }

    return {
        subscribe,
        get state() {
            return state;
        },
        set ridesData(basket) {
            updateState({basket});
        },
        set product(product) {
            updateState({product});
        },
        get product() {
            return state.product;
        },
        get basket() {
            return state.basket;
        },
        set basket(basket) {
            updateState({basket});
        },
        get errors() {
            return state.errors;
        },
        set errors(errors) {
            updateState({errors});
        },
        set productRequiredFunctionality(productRequiredFunctionality) {
            updateState({productRequiredFunctionality});
        },
        get productModal() {
            return state.productModal;
        },
        set productModal(productModal) {
            updateState({productModal});
        },
        get onProductModalHide() {
            return state.onProductModalHide;
        },
        set onProductModalHide(onProductModalHide) {
            updateState({onProductModalHide});
        },
        get offerAvailable() {
            return state.offerAvailable;
        },
        set offerAvailable(offerAvailable) {
            updateState({offerAvailable});
        },
        get usage() {
            return state.usage;
        },
        set usage(usage) {
            updateState({usage});
        }
    };
}

export const basketStore = BasketStore();
